export default "__VITE_ASSET__1ce8baee__"